import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

class Contact extends Component {
  
    constructor(props) {
      super(props);
      this.state = {
        name: "",
        email: "",
        message: "",
        status: "",
      };
    }
  
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, message } = this.state;

    let htmlMessage = '<div>Name: ' + name + '</div><br>' + '<div>Email: ' + email + '</div><br>' + '<div>Message: ' + message + '</div>';

    try {
      const res = await fetch("https://1n9rtkk7sk.execute-api.us-west-2.amazonaws.com/prod/sendContactEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, htmlMessage }),
      });

      const data = await res.json();
      this.setState({ status: data.message });
    } catch (error) {
      this.setState({ status: "An error occurred. Please send an email your message directly to brandonfalcone@gmail.com" });
    }
  };


  render () {

    const { name, email, message, status } = this.state;

    return (
        
      <div id="contact">

          <div className="home-me-container">
            <div className="general-text-container">
              <p className="project-text-medium">Contact</p>
              <p className="project-paragraph">Feel free to get in touch. You can use the contact form below or email me directly at brandonfalcone@gmail.com.</p>
            </div>
            <form className="form" onSubmit={this.handleSubmit}>
            <div>
              <label for="name">Your Name</label><br></br>
              <input
                type="text"
                name="name"
                value={name}
                onChange={this.handleChange}
                placeholder="Name"
                required
              />
            </div>
            <div>
              <label for="email">Your Email Address</label><br></br>
              <input
                type="email"
                name="email"
                value={email}
                onChange={this.handleChange}
                placeholder="Email"
                required
              />
            </div>
            <div>
              <label for="name">Your Message</label><br></br>
              <textarea
                name="message"
                value={message}
                onChange={this.handleChange}
                placeholder="Message"
                required
              />
            </div>
            <p className="project-text-small">{status}</p>
            <button type="submit">Send Message</button>
          </form>
          </div>

          

          

      </div>
    );
  }
}

export default Contact;
